// Mock data for AI AutoBots website

export const companyStats = {
  rating: "4.9",
  ratingSource: "G2",
  users: "50k+",
  trustedBy: "500+"
};

// Simple testimonials replacing company logos
export const quickTestimonials = [
  {
    id: 1,
    text: "Customer service efficiency increased by 85%",
    icon: "trending-up"
  },
  {
    id: 2,
    text: "Capture and qualify leads automatically 24/7",
    icon: "user-check"
  },
  {
    id: 3,
    text: "Round-the-clock support at 60% lower cost",
    icon: "clock"
  },
  {
    id: 4,
    text: "Resolve support tickets 3x faster",
    icon: "zap"
  },
  {
    id: 5,
    text: "AI-powered solutions that scale with you",
    icon: "cpu"
  }
];

export const heroContent = {
  tagline: "Trusted by 500+ businesses automating with AI",
  headline: "Human-like AI Agents that sell, support & book clients",
  subheadline: "AI AutoBots is the platform for ambitious teams to deploy AI agents with voice, chat, and website capabilities that scale with your business.",
  ctaPrimary: "Book a Demo",
  ctaSecondary: "Get Started Free"
};

export const agentTypes = [
  {
    id: 1,
    title: "Voice Agents for human-like phone calls",
    description: "Deploy AI-powered voice agents that handle sales calls, support inquiries, and appointment booking with natural conversation flow.",
    image: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/67d0c9fb8845ff844374a98b_phone%20(2)%20(1).webp",
    icon: "phone"
  },
  {
    id: 2,
    title: "Chat Agents with deep customization",
    description: "Build Chat Agents with powerful capabilities and interface customization for your website and messaging platforms.",
    image: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/67ca3412f778519e57e5ab04_Template.webp",
    icon: "message"
  }
];

export const features = [
  {
    id: 1,
    icon: "zap",
    title: "Built-in Automation",
    description: "Handles leads & conversations automatically, qualifying prospects and routing them to the right team."
  },
  {
    id: 2,
    icon: "phone",
    title: "Voice Agents",
    description: "Natural phone conversations that sell, support, and book appointments 24/7."
  },
  {
    id: 3,
    icon: "message-circle",
    title: "Chat Agents",
    description: "Intelligent chat widgets for your website that engage and convert visitors."
  },
  {
    id: 4,
    icon: "globe",
    title: "Website Agents",
    description: "Ready-to-deploy agents that integrate seamlessly with any website platform."
  }
];

export const useCases = [
  {
    id: 1,
    stat: "70%",
    title: "Faster Ticket Resolution",
    description: "AI agents automatically categorize, prioritize, and resolve support tickets, reducing response time and improving customer satisfaction scores.",
    icon: "ticket",
    gradient: "from-blue-500 to-cyan-500"
  },
  {
    id: 2,
    stat: "3x",
    title: "More Qualified Leads",
    description: "Intelligent lead capture and qualification running 24/7, ensuring no opportunity is missed while your team focuses on closing deals.",
    icon: "users",
    gradient: "from-purple-500 to-pink-500"
  },
  {
    id: 3,
    stat: "60%",
    title: "Lower Support Costs",
    description: "Provide round-the-clock customer service without the overhead of large support teams, dramatically reducing operational expenses.",
    icon: "dollar-sign",
    gradient: "from-green-500 to-emerald-500"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "AI AutoBots transformed our customer support. The AI agents handle the majority of inquiries, and our team can focus on complex issues. The ROI was visible within the first month.",
    author: "Sarah Chen",
    role: "VP of Customer Success",
    company: "TechScale Inc.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 2,
    quote: "The voice agents are incredibly human-like. Our customers often don't realize they're talking to AI until we tell them. Sales appointments booking has increased 3x since deployment.",
    author: "Michael Rodriguez",
    role: "Sales Director",
    company: "GrowthMotors",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 3,
    quote: "Setting up was surprisingly simple. The platform's flexibility let us customize the AI to match our brand voice perfectly. Customer satisfaction scores improved by 40%.",
    author: "Emily Thompson",
    role: "Operations Manager",
    company: "ServicePro Solutions",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face"
  }
];

export const integrations = [
  {
    id: 1,
    name: "Salesforce",
    category: "CRM",
    description: "Connect your Salesforce to power agent responses and sync customer data.",
    logo: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/65ee19d30d55f0c26e83f718_salesforce-logo%201%20(1).webp"
  },
  {
    id: 2,
    name: "Zendesk",
    category: "Support",
    description: "Integrate with Zendesk for seamless ticket management and help center sync.",
    logo: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/65eb7fb9cd37b24764d4a66b_Zendesk-Emblem-700x394.webp"
  },
  {
    id: 3,
    name: "HubSpot",
    category: "CRM",
    description: "Sync leads and conversations with HubSpot for complete visibility.",
    logo: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/65d749782882715a10e2cb8d_segment-icon-2048x2048-3p784z8x%201.svg"
  },
  {
    id: 4,
    name: "Shopify",
    category: "eCommerce",
    description: "Connect your store for product recommendations and order tracking.",
    logo: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/65ee19edff06a331aa31eef8_063e0acb0bb4ea2836b2aeedaee3ddae%201.webp"
  },
  {
    id: 5,
    name: "Slack",
    category: "Communication",
    description: "Get real-time notifications and manage agents from Slack.",
    logo: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/65ee1a65c4138edbdc9c00a8_1a62cf37-51ac-4bf7-83a1-a7979d8465a7%201%20(1).webp"
  },
  {
    id: 6,
    name: "Calendly",
    category: "Scheduling",
    description: "Book appointments directly through AI agent conversations.",
    logo: "https://cdn.prod.website-files.com/656f60dc2d85b496beec7c35/65ee1ab266cb99503dfec645_SNOW-35164165%201.webp"
  }
];

export const securityFeatures = [
  {
    id: 1,
    title: "Your AI platform of record",
    description: "Build, scale, and collaborate on AI products in a centralized, secure platform across every team."
  },
  {
    id: 2,
    title: "Get ideas to market fast",
    description: "Accelerate your AI deployment to ship with speed and quality, while efficiently scaling."
  },
  {
    id: 3,
    title: "Avoid vendor lock-in",
    description: "Bet on AI, not single vendors. Agnostically adapt to changing technologies."
  },
  {
    id: 4,
    title: "Control & customization",
    description: "Build endless integrations with secure guardrails and full customization."
  }
];

export const navItems = [
  { label: "Solutions", href: "#solutions" },
  { label: "Use Cases", href: "#use-cases" },
  { label: "Pricing", href: "#pricing" },
  { label: "Integrations", href: "#integrations" },
  { label: "About", href: "#about" }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "$299",
    period: "/month",
    description: "Perfect for small businesses getting started with AI",
    features: [
      "1 AI Agent",
      "1,000 conversations/month",
      "Chat widget integration",
      "Email support",
      "Basic analytics"
    ],
    cta: "Get Started",
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "$799",
    period: "/month",
    description: "For growing teams that need more power",
    features: [
      "3 AI Agents",
      "10,000 conversations/month",
      "Voice + Chat agents",
      "CRM integrations",
      "Priority support",
      "Advanced analytics"
    ],
    cta: "Get Started",
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "For large organizations with custom needs",
    features: [
      "Unlimited AI Agents",
      "Unlimited conversations",
      "Voice, Chat & Website agents",
      "Custom integrations",
      "Dedicated support",
      "SLA guarantee",
      "On-premise option"
    ],
    cta: "Contact Sales",
    popular: false
  }
];
